const NAMED_ENTITIES = {
  amp: '&',
  apos: "'",
  gt: '>',
  hellip: '…',
  laquo: '«',
  ldquo: '“',
  larr: '←',
  lsquo: '‘',
  lt: '<',
  mdash: '—',
  nearr: '↗',
  nbsp: ' ',
  ndash: '–',
  quot: '"',
  raquo: '»',
  rdquo: '”',
  rsquo: '’',
  rarr: '→',
};

export function decodeViewText(value) {
  return String(value || '')
    .replace(/&(?:#(\d+)|#x([\da-f]+)|([a-z]+));/gi, (entity, decimal, hex, named) => {
      if (decimal) return String.fromCodePoint(Number(decimal));
      if (hex) return String.fromCodePoint(parseInt(hex, 16));
      return NAMED_ENTITIES[named.toLowerCase()] || entity;
    })
    // Older snapshots were created before the indexer preserved the two
    // inline concept components. Repair only the exact resulting seams.
    .replace(/([.!?])\s+turns the most useful passages/gi, '$1 Ask turns the most useful passages')
    .replace(/([.!?])\s+composes material from across the site/gi, '$1 View composes material from across the site');
}
